import { createVNode as _createVNode, resolveComponent as _resolveComponent, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vShow as _vShow, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'


const _hoisted_1 = { class: "overflow-y-auto h-screen" }
const _hoisted_2 = { class: "flex flex-row justify-between items-center border-b border-gray-lp-400" }
const _hoisted_3 = { class: "flex flex-row my-4" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-20px mr-4 text-black-lp-200" }, " Edit Produk ", -1)
const _hoisted_5 = { class: "inline-flex" }
const _hoisted_6 = { class: "flex flex-row h-screen py-6" }
const _hoisted_7 = { class: "w-2/3 px-4 text-12px xxl:text-14px" }
const _hoisted_8 = { class: "flex flex-row w-3/4" }
const _hoisted_9 = { class: "py-3 w-full mr-4" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Nama Tipe Produk", -1)
const _hoisted_11 = { class: "py-3 w-3/4" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 pb-2" }, " eCargo Product ", -1)
const _hoisted_13 = { class: "flex flex-row w-3/4" }
const _hoisted_14 = { class: "py-3 w-full mr-4" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Deskripsi", -1)
const _hoisted_16 = { class: "inline-block relative w-full" }
const _hoisted_17 = { class: "pointer-events-none absolute inset-y-0 right-0 flex items-end px-2 py-4 text-gray-700" }
const _hoisted_18 = { class: "text-12px text-gray-lp-500" }
const _hoisted_19 = { class: "flex flex-col h-full text-12px border-t border-gray-lp-400 my-6 py-6" }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Status Produk"),
  /*#__PURE__*/_createVNode("div", { class: "my-1 text-gray-lp-500 max-w-md" }, " Produk aktif akan masuk dalam daftar jenis pengiriman. Jangan khawatir status dapat di aktifkan atau di non-aktifkan kembali kapan saja ")
], -1)
const _hoisted_21 = { class: "flex flex-row text-12px xxl:text-14px items-center text-black-lp-300" }
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "toggle-knob bg-white inline-block" }, null, -1)
const _hoisted_23 = { class: "ml-4" }
const _hoisted_24 = { class: "w-1/3 px-8 text-12px xxl:text-14px border-l border-gray-lp-400" }
const _hoisted_25 = { class: "py-3" }
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Status Produk", -1)
const _hoisted_27 = { class: "my-1 text-black-lp-300" }
const _hoisted_28 = { class: "flex" }
const _hoisted_29 = { class: "py-3" }
const _hoisted_30 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Tanggal Dibuat", -1)
const _hoisted_31 = { class: "my-1 text-black-lp-300" }
const _hoisted_32 = { class: "text-gray-lp-500" }
const _hoisted_33 = { class: "py-3" }
const _hoisted_34 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Terakhir Diubah", -1)
const _hoisted_35 = { class: "my-1 text-black-lp-300" }
const _hoisted_36 = { class: "text-gray-lp-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_MultipleSelectSearch = _resolveComponent("MultipleSelectSearch")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("img", {
            src: _imports_0,
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
            class: "w-5 mr-3 cursor-pointer",
            alt: "arrow-left"
          }),
          _hoisted_4
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_button_fill, {
            title: "Simpan",
            onClick: _ctx.onOpenSave,
            class: "px-8 bg-red-lp-300"
          }, null, 8, ["onClick"])
        ])
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, [
              _hoisted_10,
              _createVNode("input", {
                type: "text",
                placeholder: _ctx.dataDetail.name,
                class: 
                `py-1.5 xxl:py-3 px-4 rounded border border-gray-lp-400 focus:outline-none focus:shadow my-1 text-black-lp-300 w-full ${_ctx.isDisabled &&
                  'bg-white'}`
              ,
                disabled: _ctx.isDisabled
              }, null, 10, ["placeholder", "disabled"])
            ])
          ]),
          _createVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(_component_MultipleSelectSearch, {
              options: _ctx.eCargoProductListData,
              modelValue: _ctx.eCargoProduct,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.eCargoProduct = $event)),
              modalTitle: "eCargo Product",
              keyName: "name",
              keyValue: "value",
              placeholder: "Pilih eCargo product"
            }, null, 8, ["options", "modelValue"])
          ]),
          _createVNode("div", _hoisted_13, [
            _createVNode("div", _hoisted_14, [
              _hoisted_15,
              _createVNode("div", _hoisted_16, [
                _withDirectives(_createVNode("textarea", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.description = $event)),
                  onInput: _cache[4] || (_cache[4] = e => _ctx.inputDescription(e.target.value)),
                  cols: "70",
                  rows: "7",
                  maxlength: "1000",
                  placeholder: "Tulis deskripsi produk disini",
                  class: 
                  `focus:border-red-lp-100
              py-1.5 xxl:py-3 px-4 rounded border focus:outline-none focus:shadow my-1
              text-black-lp-300 w-full ${_ctx.isDisabled && 'bg-white'}`
                
                }, null, 34), [
                  [_vModelText, _ctx.description]
                ]),
                _createVNode("div", _hoisted_17, [
                  _createVNode("p", _hoisted_18, _toDisplayString(_ctx.dataDetail.description.length) + "/1000 ", 1)
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_19, [
            _hoisted_20,
            _createVNode("div", _hoisted_21, [
              _createVNode("div", {
                onClick: _cache[5] || (_cache[5] = () => _ctx.onOpenRoute()),
                class: 
                `toggle-switch inline-block cursor-pointer ${
                  _ctx.isRoute() ? 'toggle-active bg-red-lp-100' : 'bg-gray-lp-200'
                }`
              
              }, [
                _hoisted_22
              ], 2),
              _createVNode("div", _hoisted_23, " Produk " + _toDisplayString(_ctx.isRoute() ? "Aktif" : "Tidak Aktif"), 1)
            ])
          ])
        ]),
        _createVNode("div", _hoisted_24, [
          _createVNode("div", _hoisted_25, [
            _hoisted_26,
            _createVNode("div", _hoisted_27, [
              _createVNode("div", _hoisted_28, [
                _createVNode("div", {
                  class: 
                  `rounded-full px-2 py-0 font-medium ${
                    _ctx.isRoute() ? 'bg-green-lp-300' : 'bg-red-lp-600'
                  } ${_ctx.isRoute() ? 'text-green-lp-200' : 'text-red-lp-500'}`
                
                }, _toDisplayString(_ctx.isRoute() ? "Active" : "Inactive"), 3)
              ])
            ])
          ]),
          _createVNode("div", _hoisted_29, [
            _hoisted_30,
            _createVNode("div", _hoisted_31, _toDisplayString(_ctx.createdAt), 1),
            _createVNode("div", _hoisted_32, _toDisplayString(_ctx.createdBy), 1)
          ]),
          _createVNode("div", _hoisted_33, [
            _hoisted_34,
            _createVNode("div", _hoisted_35, _toDisplayString(_ctx.updateAt), 1),
            _createVNode("div", _hoisted_36, _toDisplayString(_ctx.updateBy), 1)
          ])
        ])
      ])
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onClose: _ctx.onCloseRoute,
      onSubmit: _ctx.changeRoute,
      title: _ctx.isRoute() ? 'Non-aktifkan Produk' : 'Aktifkan Produk',
      message: 
      _ctx.isRoute()
        ? 'Selama produk berstatus non-aktif maka produk tidak dapat digunakan dalam tipe pengiriman.'
        : 'Selama produk berstatus aktif maka produk dapat digunakan dalam tipe pengiriman.'
    ,
      image: "warning",
      textSuccess: _ctx.isRoute() ? 'Non-aktifkan' : 'Aktifkan',
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onClose", "onSubmit", "title", "message", "textSuccess"]), [
      [_vShow, _ctx.openRoute]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onCloseSuccess,
      title: "Perubahan Disimpan",
      message: `${_ctx.messageSuccess}`,
      image: "image-modal-success",
      textSuccess: "Oke",
      class: "px-8"
    }, null, 8, ["onSubmit", "message"]), [
      [_vShow, _ctx.openSuccess]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onCloseModalSuccess,
      title: "Perubahan Disimpan",
      message: `Detail Produk “${_ctx.dataDetail.name}” berhasil diubah`,
      image: "image-modal-success",
      textSuccess: "Oke",
      class: "px-8"
    }, null, 8, ["onSubmit", "message"]), [
      [_vShow, _ctx.openModalSuccess]
    ]),
    (_ctx.isError)
      ? (_openBlock(), _createBlock(_component_ErrorMessage, {
          key: 0,
          onCancel: _ctx.handleErrorClose,
          errorType: _ctx.errorCause,
          onTryAgain: _ctx.fetchProductData,
          modal: ""
        }, null, 8, ["onCancel", "errorType", "onTryAgain"]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.handlerClose,
      onClose: _ctx.handlerCancelClose,
      title: "Yakin Keluar Halaman ?",
      message: "Anda belum selesai mengisi form. Permintaan tidak akan diproses jika Anda keluar dari halaman ini.",
      image: "are-you-sure",
      textSuccess: "Keluar",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose"]), [
      [_vShow, _ctx.isEditTerminated]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx._onEdit,
      onClose: _ctx.onCloseSave,
      title: "Konfirmasi Perubahan Detail Produk",
      message: 
      `Anda yakin akan menyimpan perubahan untuk Produk “${_ctx.dataDetail.name}”`
    ,
      image: "are-you-sure",
      textSuccess: "Simpan",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "message"]), [
      [_vShow, _ctx.openSave()]
    ])
  ], 64))
}